import { gql, useMutation } from '@apollo/client';
import { GET_USER } from './useUserQuery';
import { GetDpoInfo } from '../dpo/useDpoInfoQuery';

const DELETE_DPO_AVATAR = gql`
  mutation deleteDpoAvatar($userId: String!) {
    deleteDpoAvatar(userId: $userId) {
      id
      dpoAvatarUrl
    }
  }
`;

export const useUserDeleteDpoAvatarMutation = () => {
  return useMutation(DELETE_DPO_AVATAR, {
    refetchQueries: [GET_USER, GetDpoInfo],
  });
};
